/**
 * Scenarios (spec §15): named Plan variants held in memory and included in
 * export payloads. Up to 10; compare 3 side by side.
 */
import type { Plan } from '../model/types';

export const MAX_SCENARIOS = 10;
export const MAX_COMPARE = 3;

export interface Scenario {
  id: string;
  name: string;
  plan: Plan;
}

let scenarioCounter = 0;

/**
 * Unique ACROSS SESSIONS, which the bare counter was not: it resets to 0 on
 * every page load while saved files keep the ids they were written with. Load a
 * file holding `scn_1_1` and the next scenario you add was handed that same id.
 * Duplicate ids are corrosive here — React reconciles the two rows as one, and
 * every id-keyed update (rename, delete, compare, overwrite) lands on both, so
 * typing in one scenario visibly edits another.
 *
 * Timestamp for cross-session separation, counter for ordering within a session
 * (two adds in the same millisecond), random suffix so two browser tabs opened
 * at once can't agree either.
 */
export function newScenarioId(): string {
  scenarioCounter += 1;
  const stamp = Date.now().toString(36);
  const rand = Math.random().toString(36).slice(2, 8);
  return `scn_${stamp}_${scenarioCounter.toString(36)}_${rand}`;
}
